export default __webpack_public_path__ + "static/media/call-icon.387c17ba.svg";